export const setEditSaveState = (state, action): any => {
  const updatedState = {
    ...state,
    saveEditResponse: action.payload.status,
  };

  return updatedState;
};
